const transformArrayToObject = <T>(array: Array<T>, fieldAsKey: keyof T) =>
  array.reduce<Record<string, T>>((object, item) => {
    const key = item[fieldAsKey];
    if (typeof key === 'string' || typeof key === 'number') {
      // TODO ts bug
      // @ts-ignore
      object[key] = item;
      return object;
    }
    throw new Error('The key value type must be a string or a number.');
  }, {});

const convertNullValuesToUndefined = (object: object): object => {
  return Object.entries(object).reduce((acc, [key, value]) => {
    acc[key] = value ?? undefined;
    return acc;
  }, {});
};

/**
 * These wrappers are helpful for preventing implicit type casts like: 'aaa' | 'bbb' => string.
 * See usages in the code
 */
const getObjectEntries = Object.entries as <T>(obj: T) => Array<[keyof T, T[keyof T]]>;
const getObjectKeys = Object.keys as <T>(obj: T) => Array<keyof T>;
const getObjectValues = Object.values as <T>(obj: T) => Array<T[keyof T]>;

export {
  transformArrayToObject,
  convertNullValuesToUndefined,
  getObjectEntries,
  getObjectKeys,
  getObjectValues,
};
